const mutations = {
    SET_ERROR_SUPPLY_LISTS(state, payload) {
        state.error = payload;
    }
};

export default mutations;
